import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectSupplierInfo } from "../../../../store/slices/supplierInfoSlice";
import { useSectionNumbering } from "../hooks/useSectionNumbering";
import InfoRow from "./InfoRow";

const GeneralsSection = ({ title }) => {
    const { sectionNumbers } = useSectionNumbering();
    const supplierInfo = useSelector(selectSupplierInfo);
    const { amounts } = supplierInfo || { amounts: {} };
    const { generalsValues } = amounts || {};

    // Don't render if no generals data
    if (!generalsValues || generalsValues.length === 0) {
        return null;
    }

    return (
        <>
            <hr />
            <Row>
                <Col md={8}>
                    <strong>{title}</strong>
                </Col>
            </Row>
            {generalsValues.map((general, index) => (
                <Row key={general.id || index}>
                    <Col xs={8}>
                        <InfoRow
                            label={`${sectionNumbers.generals?.[index]}. ${general.label}`}
                            value={general.percent || 0}
                            name="vatRate"
                            suffix="%"
                        />
                    </Col>
                    <Col xs={4}>
                        <InfoRow
                            label=""
                            value={general.amount || 0}
                            name="generalAmount"
                            suffix="€"
                            isNegative={general.amount < 0}
                        />
                    </Col>
                </Row>
            ))}
            <hr />
        </>
    );
};

export default GeneralsSection;
